import { Record } from "immutable";

export type MemoryType = {
  id?: string | null;
  courseId: string | null;
  courseName: string | null;
  sectionId: string | null;
  sectionTitle: string | null;
  locationId: string | null;
  timeEarned: string | null;
};

export type OptionalMemoryType = Partial<MemoryType>;

const defaultMemory: MemoryType = {
  id: null,
  courseId: null,
  courseName: null,
  sectionId: null,
  sectionTitle: null,
  locationId: null,
  timeEarned: null
};

export default class Memory extends Record(defaultMemory) {}
